import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import usersService from "../../services/userService";

const initialState = {
  userInfo: [],
  leaderBoardInfo: [],
};

export const get_user_info = createAsyncThunk(
  "user/getUserInfo",
  () => {
    return usersService
      .getUserInfo()
      .then((response) => response.data);
  }
);

export const get_leaderboard_info = createAsyncThunk(
  "user/getLeaderboardInfo",
  () => {
    return usersService
      .getLeaderBoadrInfo()
      .then((response) => response.data);
  }
);

const userSlice = createSlice({
  name: "user",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(get_user_info.fulfilled, (state, action) => {
      state.userInfo = action.payload;
    });
    builder.addCase(get_leaderboard_info.fulfilled, (state, action) => {
      state.leaderBoardInfo = action.payload;
    });
  },
});

export default userSlice.reducer;
